// purchaseOrderItemsDisplayPrefs.js
//
// Local display preferences for the Purchase Order Items table.

import {
  readScopedPreferenceMap,
  writeScopedPreferenceMap,
} from 'views/utils/organicViews';

export const PURCHASE_ORDER_ITEMS_DISPLAY_PREFS_STORAGE_KEY = 'appdeck.purchaseOrderItems.displayPrefs.v1';

export const DEFAULT_PURCHASE_ORDER_ITEMS_DISPLAY_PREFS = {
  showCoverPhoto: true,
  showDescription: true,
  showLineNumber: true,
};

function cleanScopeKey(baseKey) {
  return String(baseKey || '').trim() || '_';
}

/**
 * @param {unknown} value
 * @returns {{
 *   showCoverPhoto: boolean,
 *   showDescription: boolean,
 *   showLineNumber: boolean,
 * }}
 */
export function normalizePurchaseOrderItemsDisplayPrefs(value) {
  const source = value && typeof value === 'object' ? value : {};
  return {
    showCoverPhoto: source.showCoverPhoto !== false,
    showDescription: source.showDescription !== false,
    showLineNumber: source.showLineNumber !== false,
  };
}

/**
 * @param {string} [baseKey]
 * @returns {{
 *   showCoverPhoto: boolean,
 *   showDescription: boolean,
 *   showLineNumber: boolean,
 * }}
 */
export function readPurchaseOrderItemsDisplayPrefs(baseKey) {
  const map = readScopedPreferenceMap(PURCHASE_ORDER_ITEMS_DISPLAY_PREFS_STORAGE_KEY);
  return normalizePurchaseOrderItemsDisplayPrefs(map[cleanScopeKey(baseKey)]);
}

/**
 * @param {string} [baseKey]
 * @param {object} prefs
 * @returns {{
 *   showCoverPhoto: boolean,
 *   showDescription: boolean,
 *   showLineNumber: boolean,
 * }}
 */
export function writePurchaseOrderItemsDisplayPrefs(baseKey, prefs) {
  const scope = cleanScopeKey(baseKey);
  const nextPrefs = normalizePurchaseOrderItemsDisplayPrefs(prefs);
  const map = readScopedPreferenceMap(PURCHASE_ORDER_ITEMS_DISPLAY_PREFS_STORAGE_KEY);
  writeScopedPreferenceMap(PURCHASE_ORDER_ITEMS_DISPLAY_PREFS_STORAGE_KEY, {
    ...map,
    [scope]: nextPrefs,
  });
  return nextPrefs;
}
